<template>
  <div class="headernavigation drRtl">
    <!-- responsive navbar  -->
    <div
      data-aos="fade-left"
      v-if="navbarresponsive"
      class="responsive__navbarMenu"
    >
      <div
        @click="navbarresponsive = !navbarresponsive"
        class="responsive__navbarBox"
      >
        <span class="CloseIcon"> <CloseIcon class="close" /> </span>

        <h1 class="responsive__navbar__logo">
          <router-link to="/">
            <img :src="'https://gorgon.ir/storage/' +
                  $root.globalData.settings.logo_pages" alt="لوگو وبسایت" />
          </router-link>
        </h1>

        <hr class="hr" />

        <div class="responsive__navigation">
          <nav>
            <ul class="responsive__navigation__menu">
              <li
                navbar__menu__list
                v-for="(item, index) in $root.globalData.menus.header"
                :key="index"
              >
                <router-link
                  class="responsive__items"
                  v-if="item.linkable_type != null"
                  :to="findUrl(item.linkable_type, item.linkable_id, item.slug)"
                >
                  {{ item.title }}
                </router-link>
                <a v-else class="responsive__items2" :href="item.link">
                  {{ item.title }}
                </a>
              </li>
            </ul>

            <!-- findUrl(
                      childrenMenu.linkable_type,
                      childrenMenu.linkable_id,
                      childrenMenu.slug
                    )" -->
          </nav>
        </div>
      </div>
    </div>

    <!-- navbar icon  -->
    <div class="headernavigation__box w margin">
      <div
        @click="navbarresponsive = !navbarresponsive"
        class="hamburger__menu"
      >
        <HamburgerMenu class="hambergur__icon" />
      </div>

      <!-- website logo  -->

      <div class="logo">
        <router-link to="/">
          <img
            id="logo"
            :src="
              $route.path != '/'
                ? 'https://gorgon.ir/storage/' +
                  $root.globalData.settings.logo_pages
                : screenSize > 768
                ? 'https://gorgon.ir/storage/' + $root.globalData.settings.logo
                : 'https://gorgon.ir/storage/' +
                  $root.globalData.settings.logo_pages"
            alt="لوگو"
          />
        </router-link>
      </div>
      <!-- language switcher -->
      <div v-if="$root.globalData" id="languageMobile" class="lang">
        <select v-model="language" id="selectLanguage" class="Lang__Change">
          <option
            v-for="(item, index) in $root.globalData.languages"
            :key="index"
            :value="item.name"
            :selected="index == 0 ? 'selected' : ''"
          >
            {{ item.label }}
          </option>
        </select>
      </div>
      <!-- navigation  -->
      <div v-if="$root.globalData" class="navbar">
        <ul class="navbar__menu">
          <li
            class="navbar__menu__list"
            v-for="(item, index) in $root.globalData.menus.header"
            :key="index"
          >
            <router-link
              class="responsive__items1"
              v-if="item.linkable_type != null"
              :to="findUrl(item.linkable_type, item.linkable_id, item.slug)"
            >
              {{ item.title }}
            </router-link>
            <a v-else class="responsive__items2" :href="item.link">
              {{ item.title }}
            </a>
          </li>
        </ul>
      </div>

      <!-- <div class="Search_And_Add_box">
        <span @click="handleFocusOut"> <SearchIcon /></span>
        <router-link to="/" class="addbtn" type="button">ثبت شرکت</router-link>

        <template v-if="SearchInput">
          <div data-aos="fade-up" class="searchbox">
            <spam class="Triangle"></spam>
            <form action="">
              <input
                @blur="SearchInput = false"
                id="search"
                type="text"
                placeholder="جستجو کنید..."
              />
            </form>
          </div>
        </template>
      </div> -->
    </div>
  </div>
</template>

<script>
import findUrl from "@/assets/links/LinkResolver.js";
import SearchIcon from "../svgs/SearchIcon.vue";
import Logo from "../../assets/images/logo.png";
import Logo1 from "../../assets/images/logoBlue.png";
import HamburgerMenu from "../svgs/HamburgerMenu.vue";
import CloseIcon from "../svgs/CloseIcon.vue";
export default {
  data() {
    return {
      navbarresponsive: false,
      SearchInput: false,
      screenSize: 0,
      language: "",
      logo: Logo,
      logo1: Logo1,
      NavbarItems: [
        { name: "صفحه اصلی", route: "/" },
        { name: "صنایع", route: "/Industry" },
        { name: "وبلاگ", route: "/BlogPage" },
        { name: "درباره ما", route: "/AboutUs" },
        { name: "تماس باما", route: "/ContactUs" }
      ]
    };
  },
  mounted() {
    if (this.$cookie.get("language")) {
      this.language = this.$cookie.get("language");
    } else {
      this.language = "fa";
      this.$cookie.set("language", "fa");
    }
    this.setScreenSize();
    window.addEventListener("resize", this.setScreenSize);
  },

  beforeUnmount() {
    window.removeEventListener("resize", this.setScreenSize);
  },

  methods: {
    findUrl,
    setScreenSize() {
      this.screenSize = window.innerWidth;
    },

    handleFocusOut() {
      this.SearchInput = true;
      setTimeout(() => {
        document.getElementById("search").focus();
      }, 500);
    }
  },
  watch: {
    language(newVal) {
      if (newVal != this.$cookie.get("language")) {
        this.$cookie.set("language", newVal);
        this.$axios.defaults.headers.common["accept-language"] = newVal;
        this.$router.go(0);
      }
    }
  },
  components: { SearchIcon, HamburgerMenu, CloseIcon }
};
</script>

<style scoped>
/* .navbar {
  width: 60%;
  overflow: auto;
} */
.navbar::-webkit-scrollbar {
  width: 2px;
  background-color: #f5f5f500;
}
.navbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
  background-color: #655e5c;
}
.navbar::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgb(0 0 0 / 30%);
  border-radius: 10px;
  background-color: #605b5d4f;
}
.headernavigation {
  width: 100%;
  background-color: rgba(255, 255, 255, 0.199);
}

.headernavigation__box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333;
}

.hamburger__menu {
  display: none;
}

.hambergur__icon {
  cursor: pointer;
}

.responsive__navbarMenu {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 400;
  display: none;
}
.responsive__navbarBox {
  width: 80%;
  height: 100%;
  background-color: #fff;
}

.logo {
  padding: 1rem 0;
}

.Search_And_Add_box {
  display: flex;
  align-items: center;
  position: relative;
}

.searchbox {
  position: absolute;
  top: 5em;
  width: 250px;
  background-color: #fff;
  padding: 1rem;
  border-radius: 10px;
}

.searchbox input {
  width: 100%;
  background-color: transparent;
  border-bottom: 2px solid #e3e3e3;
  outline: none;
  font-size: 13px;
  color: #333;
  padding: 10px 0;
}

::placeholder {
  color: #333;
}

.Triangle {
  width: 0;
  height: 0;
  border-left: 15px solid transparent;
  border-right: 15px solid transparent;
  border-bottom: 20px solid #fff;
  position: absolute;
  top: 0;
  right: 10px;
  transform: translateY(-20px);
}
.input::placeholder {
  color: #fff;
}

.navbar__menu {
  display: flex;
  justify-content: center;
}
.navbar__menu__list {
  padding: 0 2rem;
  cursor: pointer;
}

.navbar__menu__list a {
  color: #fff;
  width: max-content;
  display: block;
}

.addbtn {
  background-color: #3d8bfd;
  color: #fff;
  padding: 10px 1.5rem;
  border-radius: 10px;
  border: 2px solid #3d8bfd;
  transition: all ease 0.5s;
  cursor: pointer;
}

.addbtn:hover {
  background-color: transparent;
}

.responsive__navbar__logo img {
  width: 150px;
}

.CloseIcon {
  display: block;
  width: 100%;
  text-align: left;
  padding: 5px 0;
}

.close {
  cursor: pointer;
  animation: circle 2s infinite;
}

.responsive__navigation__menu {
  text-align: right;
}

.responsive__navigation__menu li {
  padding: 1rem;
}

.responsive__navigation__menu li:hover {
  background-color: #3d8bfd;
}

.responsive__navigation__menu li:hover .responsive__items {
  color: #fff;
}
.responsive__items {
  color: #000;
}

.hr {
  border: 1px solid #ccc;
}
@keyframes circle {
  0% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 768px) {
  .headernavigation {
    background-color: #fff;
    color: #000;
  }

  .responsive__navbarMenu {
    display: block;
  }

  .navbar,
  .Search_And_Add_box {
    display: none;
  }

  .headernavigation__box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #logo {
    width: 100px;
    justify-content: flex-end;
  }

  .hamburger__menu {
    display: block;
  }
}
.navbar {
  width: 80%;
}
#languageMobile {
  display: none;
}
@media (max-width: 768px) {
  #languageMobile {
    display: block;
  }
}
.logo {
  width: 100px;
}
.logo img {
  width: 100%;
}
</style>
